Namespace 'CustomerVisualMode.Charts'

class CustomerVisualMode.Charts.PercentageLabelView extends Backbone.View
  template: JST['backbone/templates/customer_visual_mode/charts/first_metrics/percentage_label']

  initialize: ({count, percentage, type}) ->
    @count = count
    @percentage = percentage
    @type = type
    @color = @_getColor(type)

  render: ->
    @$el.html @template({
      count: @count,
      percentage: @percentage
      translations: {
        count: @_getCountTranslation()
      }
    })
    @_addColor()
    @

  _getCountTranslation: ->
    @_typeFormatMap(@type).countTranslation

  _getColor: (type) ->
    format = @_typeFormatMap(type).color

  _typeFormatMap: (type) ->
    translations = @_translations()
    format = {
      positive: {
        color: 'green',
        countTranslation: "#{translations.inThe} #{translations.sla}"
      },
      negative: {
        color: 'red',
        countTranslation: "#{translations.outsideThe} #{translations.sla}"
      }
    }[type]
    throw new Error("the type: #{type} is invalid") unless format

    format

  _translations: ->
    {
      sla: I18n.t('customer_visual_mode.charts.first_metrics.sla'),
      inThe: I18n.t('customer_visual_mode.charts.first_metrics.in_the'),
      outsideThe: I18n.t('customer_visual_mode.charts.first_metrics.outside_the')
    }

  _addColor: ->
    @$el.find('.percentage').addClass(@color)
    @$el.find('.percentage-symbol').addClass(@color)
    @$el.find('.count').addClass(@color)
    @$el.find('.count-translation').addClass(@color)
